import { get as _get } from "lodash";
import { BigNumber } from "bignumber.js";
import { utils as koilibUtils } from "koilib";

const getQuote = (amount, reserveA, reserveB) => {
  return new BigNumber(amount).times(reserveB).div(reserveA);
};

/**
 * Orders two tokens like the core contract: token0 is the greater address and owns reserveA
 * (checked on mainnet, e.g. the KOIN/vUSDT pool keeps KOIN in reserveA)
 */
export const orderTokens = (tokenA, tokenB) => {
  let result = { token0: null, token1: null };
  if (tokenA.address > tokenB.address) {
    result.token0 = tokenA;
    result.token1 = tokenB;
  } else {
    result.token0 = tokenB;
    result.token1 = tokenA;
  }
  return result;
};

export const calculateAmount = (position, typed, format = true) => {
  let result = "";
  let shares = _get(position, "shares", "");
  let totalShares = _get(position, "totalSupply", "");
  let sharePercent = new BigNumber(100).multipliedBy(shares).dividedBy(totalShares);
  if (typed === "A") {
    let reserveA = _get(position, "reserves.reserveA", "");
    let decimals = _get(position, "tokenA.decimals", "0");
    result = sharePercent.multipliedBy(reserveA).dividedBy(100).toFixed(0, 1);
    if (format) {
      result = decimals != "0" ? koilibUtils.formatUnits(result, decimals) : result;
    }
  } else {
    let reserveB = _get(position, "reserves.reserveB", "");
    let decimals = _get(position, "tokenB.decimals", "0");
    result = sharePercent.multipliedBy(reserveB).dividedBy(100).toFixed(0, 1);
    if (format) {
      result = decimals != "0" ? koilibUtils.formatUnits(result, decimals) : result;
    }
  }
  return result;
};

export const calculatePercent = (position) => {
  let shares = _get(position, "shares", "");
  let totalShares = _get(position, "totalSupply", "");
  return new BigNumber(100).multipliedBy(shares).dividedBy(totalShares).toFixed(2, 0).toString();
};

export const calculateQuotes = ({ reserves = {}, amount = "", assets = [], baseAsset = {} }) => {
  let results = {
    result: 0,
  };
  if (new BigNumber(amount).isLessThanOrEqualTo(0)) {
    throw "InsufficientLiquidity";
  }
  let { token0 } = orderTokens(assets[0], assets[1]);
  let reserveA;
  let reserveB;
  // order reserves
  if (token0.address == baseAsset.address) {
    reserveA = reserves.reserveA;
    reserveB = reserves.reserveB;
  } else {
    reserveA = reserves.reserveB;
    reserveB = reserves.reserveA;
  }
  // get quote a
  let quote = getQuote(amount, reserveA, reserveB);
  results["result"] = quote.toFixed(0).toString();
  return results;
};

/**
 * Calculates default mana value based on account_rc and returns a value as a String
 * @param {BigInt} account_rc
 * @returns String
 */
export const calculateDefaultMana = (account_rc, limitbase) => {
  // it was decided to always use 4 mana for all transactions
  if (new BigNumber(account_rc).isLessThan(limitbase ? limitbase : 100000000)) {
    return account_rc;
  }
  return new BigNumber(limitbase ? limitbase : 100000000).toString();
  // let _100 = new BigNumber(10000000000);
  // let _1000 = new BigNumber(100000000000);
  // let account_rc = new BigNumber(_account_rc)
  // // 100 KOIN or less use 90% of mana account
  // if (account_rc.isLessThan(_100)) {
  //   return new BigNumber(10).multipliedBy(account_rc).dividedBy(100).toString()
  // }
  // if (account_rc.isGreaterThan(_100) && _100.isLessThan(_1000)) {
  //   return new BigNumber(5).multipliedBy(account_rc).dividedBy(100).toString()
  // }
  // if (account_rc.isGreaterThanOrEqualTo(_1000)) {
  //   return new BigNumber(2).multipliedBy(account_rc).dividedBy(100).toString()
  // }
};
